import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { SERVER_API_URL } from "src/app/common/types/app.constants";
import { CecTable, CecTableAdminStatus, CecTableType } from "src/app/common/types/cec-table";
import { CompetitorSimple } from "src/app/common/types/competitor";
import { HttpHandlingService } from "./http-handling.service";
import { LocalStorageService } from "./localStorage";
import { ApiDataService } from "./api-data.service";

@Injectable({
    providedIn: 'root'
})
export class UtilService {

  private service = inject(ApiDataService);

    constructor(private httpHandlingService: HttpHandlingService, private localStorage: LocalStorageService, private http: HttpClient) {}

    isLoggedCompetitorAnOrganizer(competitionId: number): Observable<boolean> {
        if (this.localStorage.get('loggedCompetitor') !== null && this.localStorage.get('loggedCompetitor') !== undefined) {
            const competitor = this.localStorage.get('loggedCompetitor') as CompetitorSimple;
            return this.http.get<boolean>(SERVER_API_URL + '/api/competition-authors/' + competitionId + "/" + competitor.id, { headers: this.httpHandlingService.authorizationHeaders() });
        } else {
            return of(false);
        }
    }

    isLoggedCompetitorAnAdmin(): Observable<boolean> {
      return this.service.get<boolean>('seasons/get-admin-status');
    }

    getLoggedCompetitorId(): number | undefined {
      if (!this.localStorage.get('loggedCompetitor')) {
        return undefined;
      }

      const competitor = this.localStorage.get('loggedCompetitor') as CompetitorSimple;
      return competitor.id;
    }

    convertTableTypeToCecTableType(cecTables: CecTable[]): void {
        for (const cecTable of cecTables) {
          if (cecTable.type.toString() === CecTableType[CecTableType.LIFESTAMP]) {
            cecTable.type = CecTableType.LIFESTAMP;
          } else {
            cecTable.type = CecTableType.NORMAL;
          }
        }
      }
    
      convertTableStatusToCecTableStatus(cecTables: CecTable[]): void {
        for (const cecTable of cecTables) {
          switch (cecTable.adminStatus.toString()) {
            case CecTableAdminStatus[CecTableAdminStatus.YESORNOT]: cecTable.adminStatus = CecTableAdminStatus.YESORNOT; break;
            case CecTableAdminStatus[CecTableAdminStatus.OR]: cecTable.adminStatus = CecTableAdminStatus.OR; break;
            case CecTableAdminStatus[CecTableAdminStatus.CANCELLED]: cecTable.adminStatus = CecTableAdminStatus.CANCELLED; break;
            default: cecTable.adminStatus = CecTableAdminStatus.OK; break;
          }
        }
      }
}